module.exports = __webpack_public_path__ + "static/img/53.bb45ab1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/18/53.jpg
// module id = 714
// module chunks = 0